;(function () {
  'use strict'

  angular.module('deskfy.core').controller('AttachmentListItemController', AttachmentListItemController)

  /* @ngInject */
  function AttachmentListItemController (
    $scope,
    $translate,
    $q,
    $rootScope,
    $interval,
    $timeout,
    AssetPreviewService,
    AssetService,
    TasksService,
    ModalService,
    UploadService,
    ToastService,
    ConfirmationModalService,
    NewAssetService,
    SegmentService,
    Utils,
    BackendErrorParserService,
    UserService,
    ApprovalsService
  ) {
    const getAttachmentDetailsDialogController = () =>
      $q.when(import('../../dialogs/attachment-details/attachment-details-dialog.controller'))

    $scope.uploadingFile = null
    $scope.thumbUrl = ''
    if ($scope.attachment.tasks && $scope.attachment.tasks[0].title) {
      $scope.relatedTaskName = Utils.truncateText($scope.attachment.tasks[0].title, 8)
    }

    $scope.flags = {
      loading: false,
      uploading: false,
      paused: false,
      error: false
    }

    const api = {
      getAttachmentDetailsDialogController,
      _uploadAsset,
      _checkPendingAttachment,
      _checkFileUrlAttachment,
      _setAttachmentInfo,
      _handleDeleteAsset,
      _handleUploadAssetSuccess,
      _handleUploadAssetError,
      _handleUploadAssetProgress,
      _getPreviewAssets,
      _sortAttachmentsBy,
      _openOldAttachmentDetailsDialog,
      _openAttachmentAssetPreview,
      _assetsToAttach,
      _assetsToUploadAndAttach,
      _uploadNewVersionToS3,
      _handleFileS3UploadEvents
    }
    this.getApi = () => api

    let oldModalReference

    activate()

    function activate () {
      api._checkPendingAttachment()
      api._checkFileUrlAttachment()
    }

    $scope.getDropdownOpenPosition = index => {
      const position = 'right'

      if (!index) {
        return position
      } else if (Number.isInteger((parseInt(index) + 1) / 4)) {
        return 'left'
      }

      return position
    }

    $scope.parseInt = function (string) {
      return parseInt(string)
    }

    $scope.download = function (id, taskId) {
      const originType = $scope.attachment?.tasks[0]?.originType
      if (!id) {
        id = $scope.attachment.asset.file.id
      }
      if (!taskId) {
        taskId = $scope.attachment.tasks[0].taskId
      }
      $scope.attachment.downloaded = true
      AssetService.downloadAsset(id, 'WORKFLOW')
      TasksService.setTaskAttachmentAsVisualized(taskId, id).then(() => {
        $scope.attachment.visualizedTasks = true
      })

      SegmentService.track('download-attachment', { task_id: taskId, asset_id: id, type: originType })
    }

    $scope.changeIsPrivate = function (id) {
      if (!id) {
        id = $scope.attachment.asset.file.id
      }

      const publicPrivateTranslation = $scope.attachment.tasks[0].isPrivate ? 'turnAttachmentPublic' : 'turnAttachmentPrivate'

      ConfirmationModalService.createModal({
        title: $translate.instant(`${publicPrivateTranslation}.title`),
        description: $translate.instant(`${publicPrivateTranslation}.description`),
        buttonCancelText: $translate.instant('cancel'),
        buttonConfirmText: $translate.instant(`${publicPrivateTranslation}.confirm`),
        onConfirm: () => {
          TasksService.changeIsPrivate(id, !$scope.attachment.tasks[0].isPrivate)
            .then(() => {
              $scope.attachment.tasks[0].isPrivate = !$scope.attachment.tasks[0].isPrivate
              $scope.$emit('workflow.reloadAttachments')
            })
            .catch(() => {
              ToastService.defaultErrorToast()
              $scope.flags.loading = false
            })
        }
      })
    }

    function _getPreviewAssets () {
      const deferred = $q.defer()

      TasksService.getAttachments($scope.attachment.tasks[0].id).then(taskAttachments => {
        const sortedAttachments = api._sortAttachmentsBy($scope.attachment, taskAttachments)
        $timeout(() => {
          deferred.resolve({
            assets: sortedAttachments,
            count: sortedAttachments.length
          })
        }, 0)
      })

      return deferred.promise
    }

    function _sortAttachmentsBy (attachment, taskAttachments) {
      let newTaskAttachments = [...taskAttachments]

      if (newTaskAttachments.length > 0) {
        const attachmentIndex = newTaskAttachments.map(e => e.id).indexOf(attachment.id)
        const elm = newTaskAttachments.splice(attachmentIndex, 1)[0]
        newTaskAttachments = [elm, ...newTaskAttachments]
        newTaskAttachments.forEach((att, index) => {
          newTaskAttachments[index].extension = att.files[0].extension
          newTaskAttachments[index].name = att.files[0].name
          newTaskAttachments[index].isPrivate = att.tasks[0].isPrivate
        })
      }

      return newTaskAttachments
    }

    $scope.openAttachmentDetails = function (attachment, openCommentsTab) {
      if ($scope.noInteraction) {
        return
      }

      $scope.$emit('workflow.clearSelectAttachments')
      attachment.visualizedTasks = true
      const attachmentTask = attachment?.tasks[0]
      const attachmentId = attachment?.id || attachment?.asset?.file?.id
      const openPreview = shouldOpenNewPreview => {
        TasksService.setTaskAttachmentAsVisualized(attachmentTask.id, attachmentId).then(() => {
          $timeout($scope.$emit('workflow.reloadAttachmentsCount'), 250, false)
        })

        if (shouldOpenNewPreview) {
          if (attachment?.asset?.file) {
            api._openAttachmentAssetPreview(attachment?.asset?.file, openCommentsTab)
          } else {
            api._openAttachmentAssetPreview(attachment, openCommentsTab)
          }

          return
        }

        api._openOldAttachmentDetailsDialog(attachment, openCommentsTab)
      }

      oldModalReference = ModalService.getCurrentModal()
      const attachmentTaskCreationDate = new Date(attachmentTask.createdAt)
      const breakingChangesReleaseDate = new Date('2024-03-11') // Attachment preview release date, any pin earlier from this date will not be positioned correctly.

      if (!$rootScope.isDesktop) {
        $scope.$emit('mobile.attachment-dialog-open', true)
      }

      if (attachmentTaskCreationDate > breakingChangesReleaseDate) {
        return openPreview(true)
      }

      // If the task was created before the breaking changes release date, then we should check if the attachment has any pin created before the release date, so we show the old preview dialog
      TasksService.getAssetPins(attachmentId).then(pins => {
        const hasOldPin = pins.some(pin => new Date(pin.createdAt) <= breakingChangesReleaseDate)

        if (hasOldPin) {
          openPreview(false)
          return
        }

        openPreview(true)
      })
    }

    function _openOldAttachmentDetailsDialog (attachment, focus) {
      api.getAttachmentDetailsDialogController().then(({ AttachmentDetailsDialogController }) => {
        ModalService.showModal({
          templateId: 'attachmentDetails.html',
          templateUrl: '/core/dialogs/attachment-details/attachment-details-dialog.html?$$REVISION$$',
          destroyable: true,
          observeChanges: true,
          allowMultiple: true,
          controller: AttachmentDetailsDialogController,
          data: {
            showIsPrivate: true,
            attachment,
            focus
          }
        }).then(() => {
          if (oldModalReference) {
            ModalService.setCurrentModal(oldModalReference)
            ModalService.showCurrentModal()
            $scope.$emit('workflow.reloadAttachments')
            $scope.$emit('workflow.reloadComments')
          }
          if (!$rootScope.isDesktop) {
            $scope.$emit('mobile.attachment-dialog-open', false)
          }
        })
      })
    }

    function _openAttachmentAssetPreview (attachment, openCommentsTab) {
      AssetService.getAssetDetailsById(attachment.id).then(asset => {
        asset.isPrivate = attachment.tasks?.[0].isPrivate
        asset.user = attachment.attachmentUser

        AssetPreviewService.openAssetPreview({
          asset: asset,
          task: $scope.task || attachment.tasks?.[0],
          onDeleteAsset: api._handleDeleteAsset,
          getPreviewAssets: api._getPreviewAssets,
          location: 'workflow',
          openTab: openCommentsTab ? 'comments' : null
        })
      })
    }

    function _handleDeleteAsset (taskId, asset) {
      if (!asset.id) {
        asset = $scope.attachment.asset.file
      }
      if (!taskId) {
        taskId = asset.tasks[0].taskId
      }

      const assetId = asset.assetId || asset.id

      ConfirmationModalService.createModal({
        title: $translate.instant('deleteAttachmentDialog.title'),
        description: $translate.instant('deleteAttachmentDialog.description'),
        buttonCancelText: $translate.instant('cancel'),
        buttonConfirmText: $translate.instant('deleteAttachmentDialog.confirm'),
        onConfirm: () => {
          TasksService.removeAttachment(taskId, assetId)
            .then(() => {
              ToastService.defaultSuccessToast()
              if ($scope.onRemove) {
                $scope.onRemove()
              }
              $rootScope.$broadcast('workflow.reloadAttachments')
              $rootScope.$emit('internal-approval-card.reload')
            })
            .catch(() => {
              ToastService.defaultErrorToast()
            })
        }
      })
    }
    $scope.handleDeleteAsset = api._handleDeleteAsset

    function _uploadAsset (asset, params) {
      $scope.flags.loading = true
      $scope.flags.uploading = true

      UploadService.generateThumbnailInBrowserAndUploadToS3(asset, {
        onUploadProgress: api._handleUploadAssetProgress,
        qualities: ['LOW', 'MID', 'HIGH'],
        webp: true,
        png: true
      })
        .then(uploadedAsset => {
          $scope.uploadingFile = null
          $scope.flags.uploading = false
          api._handleUploadAssetSuccess(params, uploadedAsset)
        })
        .catch(err => {
          if (err.code === 'ERR_CANCELED') {
            return
          }

          api._handleUploadAssetError(err)
        })
    }

    function _handleUploadAssetSuccess (params, createdAsset) {
      const file = createdAsset.files[0]

      $scope.attachment.id = createdAsset.id
      $scope.attachment.name = file.name
      $scope.attachment.createdBy = file.createdBy
      $scope.attachment.contentType = file.contentType
      $scope.attachment.extension = file.extension
      $scope.attachment.type = createdAsset.type
      $scope.attachment.tasks[0].isPrivate = params.isPrivate
      $scope.flags.loading = false

      const assetName = file.name + '.' + file.extension

      TasksService.attachAssetToTask(params.taskId, createdAsset.id, params.isPrivate, assetName).then(() => {
        ToastService.showSuccessToast($translate.instant('fileUploadSuccess'))

        SegmentService.track('added-attachment', {
          task_id: params.taskId,
          private: params.isPrivate,
          asset_id: createdAsset.id,
          type: params.isPrivate ? 'private' : 'public',
          task_type: params.originType,
          upload_form_files: false
        })

        // for some reason, sometimes $scope.$emit does not work when uploading multiple files
        $scope.$emit('workflow.reload-activity-list')
        $rootScope.$emit('workflow.reloadAttachments')
        $scope.$emit('workflow.updateTaskObject')
        api._checkFileUrlAttachment()
      })
    }

    function _handleUploadAssetError (error) {
      $scope.flags.loading = false
      $scope.flags.uploading = false
      $scope.flags.error = true

      if (BackendErrorParserService.isInvalidFileError(error)) {
        $scope.onRemove()
        ToastService.showErrorToast($translate.instant('fileExtensionNotAllowed'))
        return
      }

      if (error.xhrStatus !== 'abort') {
        ToastService.defaultErrorToast()
      }
    }

    function _handleUploadAssetProgress (file, progress) {
      $scope.uploadingFile = file

      $timeout(() => {
        $scope.attachment.progress = progress
      })
    }

    function _setAttachmentInfo () {
      const originalFile = $scope.attachment.files.find(file => file.quality === 'ORIGINAL')
      $scope.attachment.name = originalFile.name
      $scope.attachment.size = originalFile.size
      $scope.attachment.extension = originalFile.extension
    }

    function _checkPendingAttachment () {
      if ($scope.attachment.asset) {
        if (!$scope.attachment.asset.attachOnly) {
          api._assetsToUploadAndAttach()
        } else if ($scope.attachment.asset.attachOnly) {
          api._assetsToAttach()
        }
      }

      if ($scope.attachment.files) {
        api._setAttachmentInfo()
      }
    }

    function _assetsToUploadAndAttach () {
      const { file, task, isPrivate } = $scope.attachment.asset

      if (!$scope.attachment.tasks) {
        $scope.attachment.tasks = []
      }

      $scope.attachment.visualizedTasks = true
      $scope.attachment.name = file.name
      $scope.attachment.size = file.size
      $scope.attachment.tasks[0] = { taskId: task.id }
      $scope.attachment.progress = 0

      return api._uploadAsset(file, {
        taskId: task.id,
        isPrivate,
        originType: task.originType
      })
    }

    function _assetsToAttach () {
      const { file, task, isPrivate } = $scope.attachment.asset

      const taskId = task.id
      const assetId = file.id
      const taskOriginType = task.originType
      $scope.attachment.name = file.name
      $scope.attachment.size = file.size
      $scope.attachment.extension = file.extension

      if (!$scope.attachment.tasks) {
        $scope.attachment.tasks = []
      }
      $scope.attachment.tasks[0] = task

      const assetName = file.name + '.' + file.extension

      TasksService.attachAssetToTask(taskId, assetId, isPrivate, assetName).then(() => {
        SegmentService.track('added-attachment', {
          task_id: taskId,
          private: isPrivate,
          asset_id: assetId,
          type: isPrivate ? 'private' : 'public',
          task_type: taskOriginType,
          upload_form_files: true
        })
        $scope.$emit('workflow.reloadAttachments')
        $scope.$emit('workflow.reload-activity-list')

        api._checkFileUrlAttachment()
      }).catch(e => {
        if (e.data.code === 'RESOURCE_ALREADY_EXISTS') {
          ToastService.showErrorToast($translate.instant('duplicatedAttachmentError'))
          $scope.$emit('workflow.removeAttachment', assetId)
        }
      })
    }

    function _checkFileUrlAttachment () {
      const id = $scope.attachment.id || $scope.attachment.asset.file.id
      const type = $scope.attachment.type || $scope.attachment.asset.file.type
      const supportedTypes = ['VIDEO', 'PDF', 'IMAGE', 'ILLUSTRATOR', 'PHOTOSHOP']
      const hasThumb = supportedTypes.includes(type)
      const setThumb = () => {
        if (hasThumb) {
          $scope.thumbUrl = NewAssetService.getAssetThumbnailUrl(id, 'LOW', { includeDateAsQueryString: true })
        } else {
          $scope.thumbUrl = AssetService.getAssetThumbnailByType($scope.attachment || $scope.attachment.asset.file)
        }
      }
      setThumb()

      if (hasThumb) {
        const interval = $interval(() => {
          NewAssetService.checkAssetHasThumb(id, 'LOW').then(hasThumb => {
            if (!hasThumb) {
              return
            }
            $interval.cancel(interval)

            $timeout(() => {
              setThumb()
            })
          })
        }, 8000)
      }
    }

    $scope.getFileUploadAcceptance = (contentType) => {
      if (!contentType) return

      if (contentType.includes('video')) {
        return 'video/*'
      }

      return contentType
    }

    $scope.uploadNewVersion = (file) => {
      if (!file) {
        return
      }

      AssetService.getAssetDetailsById($scope.attachment.id).then(asset => {
        if (!asset.s3Key) {
          // show error toast
          ToastService.defaultErrorToast()
          return
        }

        ConfirmationModalService.createModal({
          title: $translate.instant('addNewVersionDialog.title'),
          description: $translate.instant('addNewVersionDialog.description'),
          buttonCancelText: $translate.instant('addNewVersionDialog.buttonCancelText'),
          buttonConfirmText: $translate.instant('addNewVersionDialog.buttonConfirmText'),
          hideCancelButton: false,
          onConfirm: () => {
            api._uploadNewVersionToS3(file, asset)
          },
          onCancel: () => { return false }
        })
      })
    }

    $scope.getApproverAvatar = (approverId) => {
      return UserService.getUserProfileImage(approverId)
    }

    $scope.getTooltipContentWithApproverStatus = (approver) => {
      return ApprovalsService.getApproverTooltipContentWithStatus(approver)
    }

    function _uploadNewVersionToS3 (file, asset) {
      $scope.flags.uploading = true
      $scope.thumbUrl = AssetService.getAssetThumbnailByType()
      $scope.attachment.progress = 50

      UploadService.uploadToS3(file, {
        existentS3Key: asset.s3Key,
        generateThumbnailSync: asset.s3Key.includes('-sync')
      }).then(() => {
        api._handleFileS3UploadEvents(asset)
      })
    }

    function _handleFileS3UploadEvents (asset) {
      $timeout(() => {
        $scope.flags.uploading = false
        $scope.thumbUrl = NewAssetService.getAssetThumbnailUrl(asset.id, 'LOW', { includeDateAsQueryString: true })
      }, 0, true)

      SegmentService.track('file-version-upload')
      $scope.$emit('workflow.reloadAttachments')
      $scope.$emit('workflow.reload-activity-list')
    }
  }
})()
